import { createSlice } from '@reduxjs/toolkit';

import { resetOnLogOutMatcher } from 'src/services/auth';
import { userApi } from 'src/services/user';
import { UserState } from './types';

const initialState: UserState = {
  email: '',
  firm: null,
  firstName: null,
  lastName: null,
  id: 0,
  role: 'ATTORNEY',
};

export const userSlice = createSlice({
  extraReducers: (builder) =>
    builder
      .addMatcher(
        userApi.endpoints.myProfile.matchFulfilled,
        (_, action) => action.payload || initialState,
      )
      .addMatcher(...resetOnLogOutMatcher(initialState)),
  initialState,
  name: 'user',
  reducers: {
    resetUser: () => initialState,
  },
});

export const { resetUser } = userSlice.actions;
